import React, { useEffect } from 'react';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import type { PlanIframeProps } from 'Components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater';
import 'Components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater';
import { AsyncLoader } from 'Components/widgets/loading/async-loader/AsyncLoader';
import { useFormikContext } from 'formik';
import type { PaymentFormValues } from 'Src/types/payment';
import { t } from 'Src/i18n';
import { FormFeedback } from 'Components/frameworks/form-feedback/FormFeedback';
import { usePledg } from './usePledg';
export const PledgForm = ({ onLoaded, price, display }: PlanIframeProps) => {
  const { isLoading, error } = usePledg({
    price,
    onLoaded,
    shouldInit: display,
  });
  const formik = useFormikContext<PaymentFormValues>();
  const {
    termsAndConditions: { cgv },
  } = formik.values;
  useEffect(() => {
    if (error) {
      onLoaded(false);
      formik.resetForm();
    }
  }, [error]);
  return (
    <React.Fragment>
      <Capsule header="none" className={`${display ? 'block' : 'hidden'} my-40`}>
        {isLoading && <AsyncLoader />}
        <div id="pledg-funnel-container"></div>
        <span id="pledg-button" aria-disabled="true"></span>
      </Capsule>
      {!cgv && error && <FormFeedback hasAutoScroll className="my-30" isError message={t(error)} />}
    </React.Fragment>
  );
};
